import { OdinController } from '@myosh/odin-components';
import type { ComboboxMultiselectProps } from './combobox-multiselect.component';
import ComboboxMultiselect from './combobox-multiselect.component';

interface HfComboboxMultiselectProps extends ComboboxMultiselectProps {
  name: string;
}

export default function HfComboboxMultiselect({
  control,
  name,
  value,
  onChange,
  textField,
  valueField,
  fieldValueConverter,
  ...rest
}: HfComboboxMultiselectProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      defaultValue={value}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <ComboboxMultiselect
          {...rest}
          name={name}
          control={control}
          value={value}
          onChange={onChange}
          error={error?.message}
          textField={textField}
          valueField={valueField}
        />
      )}
    />
  );
}
